import {IAuditInterface} from '../../../../global/audit.interface';
import {ChatScopEnum} from '../../activity-logs/activity-form/activity-form.component';
import {Personfield} from '../../verification-page/verification-page-dto';

export interface ActivityLogs extends IAuditInterface{
    msg_status: {
        status: string
    };
    id: number
    ip_address: string
    signable_id: number
    signable_type: string
    message?: string
    document_id: number
    device: string
    attachment: string
    scope: string
    activity_type: string
    log_status: string
    document?: RecipientRoles[]
    signable: Signable
    tags?:{
        user:{
            id: number,
            name: string
        }
    }[]
}

export interface ActivityInternalLogs {
    scope: ChatScopEnum,
    message:string,
    tags: {
        user:{
            name:string,
            id: number
        }
    }[]
}

export interface Signable {
    id: number
    tenant_owner?: boolean
    name?: string
    email?: string
    status?: string
    phone?: string
    profile_image?: string
    signature?: string
    user_id?: number
    workspace_id?: number
    recipient_id?: number
    organization_id: number
    roleable_id?: number
    roleable_type?: string
    role_name?: string
    role_color?: string
    sender_as_role?: number
    invitation_type?: string
    invitation_order?: number
    authentication_type?: string
    authentication_required?: number
    confirmation_type?: string
    signature_confirmation: string
    is_default?: number
    created_at?: string
    updated_at?: string
    person?: Personfield[]
    recipient_role_detail?:RecipientRoleDetail
    roleable?:Roleable
}

export interface RecipientRoleDetail {
  id: number
  user_id: number
  workspace_id: number
  recipient_role_id: number
  reject_comment: string
  is_sender: number
  status: string
  status_updated_at: string
  email_fialed_reason: string
  signature_image: string
  signature_type: string
  third_party_auth_response: null
  unique_id: string
  ip_address: string
  created_at: string
  updated_at: string
}

export interface Roleable {
  name: string
  id: number
  folder_name: string
  document_type_name: string
  folders?: null
  due_date: string
}

export interface RecipientRoles {
    id: number
    person: Personfield[]
    role_name: string
    roleable_id: number
    roleable_type: string
}

export enum ActivityLogStatusEnum {
    Viewed = 'viewed',
    ReadOnly = 'read_only',
    Updated = 'updated',
    ViewedAttachment = 'viewed_attachment',
    Attached = 'attached',
    Signed = 'signed',
    Uploaded = 'uploaded',
    Reminder = 'reminder',
    Expired = 'expired',
    RequestExtendDueDate = 'request_extend_due_date',
    ExtendDueDate = 'extend_due_date'
}

export enum SignableType {
    USER = 'App\\Models\\User',
    RecipientRole = 'App\\Models\\RecipientRole'
}